const SITE_TITLE = '[en]CBSN platform[/en][ja]包括脳プラットフォーム[/ja]';
const SITE_SLOGAN = 'XooNIps for CBSN';
// Replaces the Universal Analytics property (UA-2780809-1), shut down in 2023.
const GOOGLE_ANALYTICS_TRACKING_ID = 'G-CJHKDRF9PX';
const XOONIPS_ITEMTYPES = ['tool', 'paper', 'presentation', 'book', 'data', 'url', 'files'];
const D3FORUM_MODULES = ['forum'];

// Vite's BASE_URL always carries a trailing slash ('/' when the app is served
// from the document root). Strip it so it can be concatenated the same way
// CRA's Config.BASE_URL was.
const BASE_URL = import.meta.env.BASE_URL.replace(/\/$/, '');

export type MultiLang = 'en' | 'ja';

const Config = {
    SITE_TITLE,
    SITE_SLOGAN,
    GOOGLE_ANALYTICS_TRACKING_ID,
    XOONIPS_ITEMTYPES,
    D3FORUM_MODULES,
    BASE_URL,
};

export default Config;
